module.exports = __webpack_public_path__ + "img/9788932906720.d1e9776d.jpg";